<template>
  <span class="gallery-filter__option-categories js-filter-options">
    <div class="gallery-filter__search-box-container lg:mb-6">
      <svg class="icon icon-search align-top">
        <use xlink:href="#icon-search"></use>
      </svg>
      <input
        type="text"
        class="js-resources-filter-search"
        placeholder="Search Gallery"
        :value="searchTerm"
        @input="updateSearchTerm"
      />
      <!-- TODO: change the thing above here js-resources-filter-search to js-gallery-blah -->
    </div>
    <div class="gallery-filter__search-box-mobile-separator"></div>
    <div
      class="gallery-filter__option-category js-option-category"
      v-for="optionsCategory in filterOptionsCategories"
      :key="optionsCategory.id"
    >
      <div
        class="
          gallery-filter__option-category-name-wrapper
          js-category-options-toggle
        "
        :data-category="optionsCategory.id"
        @click="toggleCategoryOptions"
      >
        <span class="gallery-filter__option-category-name">
          {{ optionsCategory.displayName }}
        </span>
        <span class="js-category-collapse-icon-container">
          <icon-base
            class="
              gallery-filter__category-collapse-icon
              js-category-collapse-icon
            "
            icon-name="icon-dropdown-arrow"
            view-box="0 0 32 32"
            height="20"
          >
            <icon-dropdown-arrow />
          </icon-base>
        </span>
      </div>
      <div
        class="gallery-filter__options js-resources-filter-options hidden"
        :data-category="optionsCategory.id"
      >
        <div
          class="gallery-filter__option js-resources-filter-option"
          v-for="optionData in optionsCategory.options"
          :key="optionData.id"
          :data-id="optionData.id"
        >
          <label class="gallery-filter__option-label">
            <span class="gallery-filter__option-label-checkbox">
              <input
                type="checkbox"
                @click="
                  updateSelectedFilters(optionsCategory, optionData, $event)
                "
              />
              <div />
            </span>
            <span class="gallery-filter__option-label-text">
              {{ optionData.displayName }}
            </span>
          </label>
        </div>
      </div>
      <hr class="gallery-filter__hr" />
    </div>
    <div class="gallery-filter__mobile-buttons-wrapper js-mobile-buttons">
      <span class="gallery-filter__clear-all--mobile" @click="clearFilters">
        <svg class="icon icon-cta">
          <use xlink:href="#icon-cta"></use>
        </svg>
        <span>Clear Filter</span>
      </span>
      <span
        class="gallery-filter__apply-filters-button"
        @click="toggleCategories"
      >
        <span>Apply Filter</span>
        <svg class="icon icon-cta">
          <use xlink:href="#icon-cta"></use>
        </svg>
      </span>
    </div>
    <div class="gallery-filter__search-box-mobile-separator"></div>
  </span>
</template>

<script>
import { eventBus, REFRESH_SEARCH } from '../shared/event-bus';

export default {
  name: 'GalleryFilterOptions',
  props: ['filterOptionsCategories', 'selectedFilters', 'searchTerm'],
  data() {
    return {
      searchTermTimeoutID: null,
      locationSearchTerm: null,
    };
  },
  mounted() {
    eventBus.$on(REFRESH_SEARCH, () => {
      const search = document.querySelector('.js-resources-filter-search');

      search.value = '';
      eventBus.updateSearchTerm(search.value);
    });
  },
  methods: {
    toggleCategoryOptions(event) {
      const category = event.target.closest(
          '.js-category-options-toggle[data-category]'
        ),
        icon = category.querySelector('.js-category-collapse-icon'),
        options = category.parentNode.querySelector(
          `.js-resources-filter-options[data-category="${category.getAttribute(
            'data-category'
          )}"]`
        );

      if (options.classList.contains('hidden')) {
        options.classList.remove('hidden');
        icon.style.transform = 'rotate(180deg)';
      } else {
        options.classList.add('hidden');
        icon.style.transform = '';
      }
    },
    updateSelectedFilters(category, option, event) {
      eventBus.updateSelectedFilters({
        category: category,
        option: option,
        checked: event.target.checked,
      });
    },
    clearFilters() {
      eventBus.clearAllFilters();
      eventBus.toggleCategories();
    },
    toggleCategories() {
      eventBus.toggleCategories();
    },
    handleSelectRadio(option) {
      console.log('handleSelectRadio', option);
    },
    updateSearchTerm(event) {
      // Avoid making requests while the user is still typing with a timeout
      if (this.searchTermTimeoutID !== null) {
        clearTimeout(this.searchTermTimeoutID);
      }

      this.searchTermTimeoutID = setTimeout(() => {
        eventBus.updateSearchTerm(event.target.value);

        this.searchTermTimeoutID = null;
      }, 300);
    },
  },
};
</script>
